import { Service } from '@angular/core';

import { type AuthToken } from '@core/auth';

@Service()
export class TokenStore {
  private readonly ACCESS_TOKEN_KEY = 'rainbowSurrogacyAccessToken';
  private readonly RESET_TOKEN_KEY = 'rainbowSurrogacyResetToken';

  getAccessToken(): AuthToken | null {
    return this.getToken(this.ACCESS_TOKEN_KEY);
  }

  setAccessToken(token: AuthToken): void {
    this.setToken(this.ACCESS_TOKEN_KEY, token);
  }

  clearAccessToken(): void {
    this.clearToken(this.ACCESS_TOKEN_KEY);
  }

  hasAccessToken(): boolean {
    return this.getAccessToken() !== null;
  }

  getResetToken(): AuthToken | null {
    return this.getToken(this.RESET_TOKEN_KEY);
  }

  setResetToken(token: AuthToken): void {
    this.setToken(this.RESET_TOKEN_KEY, token);
  }

  clearResetToken(): void {
    this.clearToken(this.RESET_TOKEN_KEY);
  }

  private getToken(key: string): AuthToken | null {
    const value = localStorage.getItem(key);

    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value) as AuthToken;
    } catch {
      this.clearToken(key);
      return null;
    }
  }

  private setToken(key: string, token: AuthToken): void {
    localStorage.setItem(key, JSON.stringify(token));
  }

  private clearToken(key: string): void {
    localStorage.removeItem(key);
  }
}
